import { newUserPassword } from '../services/accountService'

function fetchNewPassword(data) {
  return () => newUserPassword(data)
}

export default fetchNewPassword



// WEBPACK FOOTER //
// ./src/alelo-logic/actions/fetchNewPassword.js